var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCinstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.862,
    height: 23.867,
    viewBox: "0 0 23.862 23.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M24.25,7.017a8.721,8.721,0,0,0-.555-2.9A6.114,6.114,0,0,0,20.2.629a8.743,8.743,0,0,0-2.9-.555C16.03.014,15.625,0,12.384,0S8.738.014,7.465.07a8.723,8.723,0,0,0-2.9.555A5.823,5.823,0,0,0,2.453,2,5.876,5.876,0,0,0,1.078,4.117a8.744,8.744,0,0,0-.555,2.9C.463,8.29.449,8.7.449,11.936s.014,3.646.07,4.919a8.72,8.72,0,0,0,.555,2.9,6.113,6.113,0,0,0,3.492,3.492,8.745,8.745,0,0,0,2.9.555c1.273.056,1.678.07,4.919.07s3.646-.014,4.919-.07a8.719,8.719,0,0,0,2.9-.555,6.1,6.1,0,0,0,3.492-3.492,8.75,8.75,0,0,0,.555-2.9c.056-1.273.07-1.678.07-4.919s0-3.646-.061-4.919ZM22.1,16.761a6.542,6.542,0,0,1-.41,2.215,3.959,3.959,0,0,1-2.266,2.266,6.565,6.565,0,0,1-2.215.41c-1.259.056-1.636.07-4.821.07s-3.567-.014-4.821-.07a6.538,6.538,0,0,1-2.215-.41,3.672,3.672,0,0,1-1.371-.891,3.711,3.711,0,0,1-.891-1.371,6.566,6.566,0,0,1-.41-2.215c-.056-1.259-.07-1.637-.07-4.821s.014-3.567.07-4.821a6.538,6.538,0,0,1,.41-2.215,3.628,3.628,0,0,1,.9-1.371,3.7,3.7,0,0,1,1.371-.89,6.569,6.569,0,0,1,2.215-.41c1.259-.056,1.637-.07,4.821-.07s3.567.014,4.821.07a6.542,6.542,0,0,1,2.215.41,3.67,3.67,0,0,1,1.371.89A3.71,3.71,0,0,1,21.69,4.91a6.568,6.568,0,0,1,.41,2.215c.056,1.259.07,1.636.07,4.821s-.014,3.557-.07,4.816Zm0,0",
    transform: "translate(-0.449 0)",
    fill: "#b07f4a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M131.08,124.5a6.131,6.131,0,1,0,6.131,6.131A6.133,6.133,0,0,0,131.08,124.5Zm0,10.108a3.977,3.977,0,1,1,3.977-3.977A3.978,3.978,0,0,1,131.08,134.608Zm0,0",
    transform: "translate(-119.144 -118.695)",
    fill: "#b07f4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M365.312,90.033a1.431,1.431,0,1,1-1.431-1.431A1.431,1.431,0,0,1,365.312,90.033Zm0,0",
    transform: "translate(-345.572 -84.471)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinstagram);
export default __webpack_public_path__ + "static/media/cinstagram.2e4ef1ae2b493df3e36e9a02dcc605dd.svg";
export { ForwardRef as ReactComponent };